"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_jss_1 = require("react-jss");
var useHighlightTextStyles = (0, react_jss_1.createUseStyles)({
    span: {
        fontWeight: 400,
    },
});
var reservedChars = "\\^$.|?*+()[{";
var buildRegex = function (keyword) {
    // Replace all regex reserved chars
    var pattern = keyword
        ? keyword
            .split("")
            .map(function (character) { return "".concat(reservedChars.includes(character) ? "\\" : "").concat(character); })
            .join("")
        : "";
    return new RegExp("(".concat(pattern, ")"), "gi");
};
var HighlightText = function (props) {
    var baseColor = props.baseColor, highlightColor = props.highlightColor, label = props.label, keyword = props.keyword;
    var classes = useHighlightTextStyles();
    var pattern = buildRegex(keyword);
    var labelStr = new String(label);
    var splitLabel = labelStr ? labelStr.split(pattern).filter(function (labelPart) { return labelPart.length > 0; }) : [];
    var spans = splitLabel.map(function (labelPart, index) {
        var color = labelPart && keyword && labelPart.toLowerCase() === keyword.toLowerCase() ? highlightColor : baseColor;
        return ((0, jsx_runtime_1.jsx)("span", { className: classes.span, style: { color: color }, children: labelPart }, index));
    });
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: spans });
};
exports.HighlightText = HighlightText;
exports.HighlightText.displayName = "HighlightText";
//# sourceMappingURL=HighlightText.js.map